import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/views/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/views/home/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, 
        // {
        //   path: '/electronics',
        //   name: 'electronics',
        //   component: resolve => require(['@/views/electronics/Electronics'], resolve),
        //   meta: {
        //     title: '电子产品'
        //   },
        //   children: [
        //     {
        //       path: '/electronics',
        //       redirect: '/electronics/pcb'
        //     },
        //     {
        //       path: '/electronics/pcb',
        //       name: 'electronics',
        //       component: resolve => require(['@/views/electronics/Electronics_Pcb'], resolve),
        //       meta: {
        //         title: '电子产品丨PCB'
        //       }
        //     }
        //   ]
        // },
        // {
        //   path: '/software',
        //   name: 'software',
        //   component: resolve => require(['@/views/software/Software'], resolve),
        //   meta: {
        //     title: '软件产品'
        //   },
        //   children: [
        //     {
        //       path: '/software',
        //       redirect: '/software/smartTown'
        //     },
        //     {
        //       path: '/software/smartTown',
        //       name: 'software',
        //       component: resolve => require(['@/views/software/Software_smartTown'], resolve),
        //       meta: {
        //         title: '软件产品丨智能小镇管理系统'
        //       }
        //     },
        //     {
        //       path: '/software/bigData',
        //       name: 'software',
        //       component: resolve => require(['@/views/software/Software_bigData'], resolve),
        //       meta: {
        //         title: '软件产品丨大数据管理系统'
        //       }
        //     }
        //   ]
        // }, 
        // {
        //   path: '/service',
        //   name: 'service',
        //   component: resolve => require(['@/views/service/Service'], resolve),
        //   meta: {
        //     title: '相关服务'
        //   }
        // }, 
        // {
        //   path: '/servicedetail',
        //   name: 'servicedetail',
        //   component: resolve => require(['@/views/service/ServiceDetail'],resolve),
        //   meta: {
        //     title: '相关服务'
        //   }
        // },
        // {
        //   path: '/companyDynamic',
        //   name: 'companyDynamic',
        //   component: resolve => require(['@/views/companyDynamic/CompanyDynamic'], resolve),
        //   meta: {
        //     title: '公司动态'
        //   }
        // }, 
        {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/views/companyIntroduction/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, 
        // {
        //   path: '/joinUs',
        //   name: 'joinUs',
        //   component: resolve => require(['@/views/joinUs/JoinUs'], resolve),
        //   meta: {
        //     title: '加入我们'
        //   }
        // }, 
        // {
        //   path: '/aboutUs',
        //   name: 'aboutUs',
        //   component: resolve => require(['@/views/aboutUs/AboutUs'], resolve),
        //   meta: {
        //     title: '关于我们'
        //   }
        // }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js